import { assign, keys, pick } from 'lodash';
import type { C, O } from 'ts-toolbelt';
import type { ReadonlyDeep } from 'type-fest';

export const pruneInput = <I extends object>(
  instance: O.Object,
  Class: C.Class<readonly unknown[], I>,
): ReadonlyDeep<I> => {
  const input = new Class();
  assign(input, pick(instance, keys(input)));
  return input as ReadonlyDeep<I>;
};
